module.exports = {
  REMITTANCE_TYPE_NEW: 'new',
  REMITTANCE_TYPE_SENT: 'sent',
};
